
import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'
import config from '../config/app.js'
import { getUserToken, getUserInfo, loginOut } from '../utils/util.js'

// electron环境下强制使用node的网络请求模块
// axios.defaults.adapter = require('axios/lib/adapters/http')

const service = axios.create({
	baseURL: config.httpRequestUrl,
	timeout: 600000
})

service.interceptors.request.use(
	config => {
		const token = getUserToken()
		const uid = getUserInfo('user_id')
		config.headers = {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer ' + token,
			...config.headers
		}
		return config
	},
	error => {
		return error
	}
)

service.interceptors.response.use(
	response => {
		if ((response.status===200 && response.data.code===20000) || (response.status===200 && response.data.code==undefined)) {
			return response.data
		} else {
			ElMessage({ showClose: true, message: '请求失败', type: 'error'})
		}
	},
	error => {
		// loginOut()
		ElMessage({showClose: true,message: '请求失败',type: 'error'})
		return error
	}
)

export default service